import React from "react";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import PropTypes from "prop-types";

class DatePickerContainer extends React.Component {
  static propTypes = {
    handleChange: PropTypes.func.isRequired,
    setDate: PropTypes.instanceOf(Date).isRequired,
  };

  render() {
    const { handleChange, setDate } = this.props;

    return (
      <DatePicker
        selected={setDate}
        onChange={(date) => {
          handleChange(date);
        }}
        showTimeSelect
        dateFormat="Pp"
        inline
        fixedHeight
        showYearDropdown
        scrollableYearDropdown
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DatePickerContainer);
